// 進階防代打卡：企業設定「偵測到代打卡時：阻擋打卡」時，BE 對不合法裝置回 400，
// body 的 error_type 為下列其一；所有打卡端點（上下班、休息、外出、卡機）格式相同。
export const DEVICE_ABNORMAL_ERROR_TYPES = ['other_user_device', 'exceed_allowed_device_count'] as const;

// 兩種異常類型目前共用同一則文案（PM 裁示），之後若要分開只改這裡。
export const DEVICE_ABNORMAL_MESSAGE_KEY = 'hr:attendance:punch_in:device_abnormal';

export const isDeviceAbnormalErrorType = (errorType?: string | null): boolean => (
	!!errorType && (DEVICE_ABNORMAL_ERROR_TYPES as readonly string[]).includes(errorType)
);

export const isDeviceAbnormalResponse = (response?: { data?: { error_type?: string } } | null): boolean => (
	isDeviceAbnormalErrorType(response?.data?.error_type)
);
